export const QUOTE_RECIPIENTS_COPY = {
  section: 'Recipients',
  signers: 'Signers',
  countersigners: 'Countersigners',
  copied: 'Copied',
  emptyState: 'All quote recipients will appear here.'
} as const
